import { render, staticRenderFns } from "./img-compress.vue?vue&type=template&id=60c06502&scoped=true&"
import script from "./img-compress.vue?vue&type=script&lang=js&"
export * from "./img-compress.vue?vue&type=script&lang=js&"
import style0 from "./img-compress.vue?vue&type=style&index=0&id=60c06502&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c06502",
  null
  
)

export default component.exports